@if (!isLoading()) {
  <div mat-dialog-title>
    @if (!data) {
      Registrera lånelöfte/limit
    } @else if (registerLoanPromiseForm.controls.type.value === 'private') {
      Lånelöfte
    } @else if (registerLoanPromiseForm.controls.type.value === 'company') {
      Limit
    }
  </div>
  <div class="holder">
    <form [formGroup]="registerLoanPromiseForm">
      <div>
        <mat-form-field>
          <mat-label>Kundtyp</mat-label>
          <mat-select
            formControlName="type"
            placeholder="Välj i listan">
            <mat-option value="private">Privat</mat-option>
            <mat-option value="company">Företag</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      @if (registerLoanPromiseForm.controls.type.value) {
        @for (applicant of applicants(); track $index) {

          @let otherSub = ($index === 0 ? applicants()[1] : applicants()[0])?.get('sub')?.value?.replace('-', '') ?? '';

          <div [formGroup]="applicant">
            @if (isPrivate) {
              <mat-form-field>
                <mat-label>
                  {{ $first ? 'Personnummer huvudlåntagare' : 'Personnummer medlåntagare' }}
                </mat-label>
                <input
                  formControlName="sub"
                  matInput
                  type="tel"
                  spbPersonnummerValidator
                  [mustBeOver18]="true"
                  [otherPersonnummers]="[otherSub]"
                >
                <mat-error>{{ applicant.controls.sub.errors?.error }}</mat-error>
              </mat-form-field>
            } @else {
              <mat-form-field>
                <mat-label>
                  {{ $first ? 'Organisationsnummer huvudlåntagare' : 'Organisationsnummer medlåntagare' }}
                </mat-label>
                <input
                  formControlName="sub"
                  matInput
                  type="tel"
                  spbPersonnummerValidator
                  [canBeOrg]="true"
                  [mustBeOver18]="true"
                  [otherPersonnummers]="[otherSub]"
                >
                <mat-error>{{ applicant.controls.sub.errors?.error }}</mat-error>
              </mat-form-field>
            }
            <mat-form-field>
              <mat-label>
                @if (isPrivate) {
                  {{ $first ? 'Namn huvudlåntagare' : 'Namn medlåntagare' }}
                } @else {
                  {{ $first ? 'Företagsnamn' : 'Företagsnamn medlåntagare' }}
                }
              </mat-label>
              <input
                formControlName="name"
                matInput
                (blur)="formatName(applicant.controls.name)"
              >
              @if (applicant.controls.name.errors?.['onlyNumbers']) {
                <mat-error>Namnet måste innehålla minst en bokstav</mat-error>
              }
            </mat-form-field>

            @if ($index === 0) {
              <mat-checkbox
                [formControl]="coApplicantCheckbox">Medlåntagare
              </mat-checkbox>
            }
          </div>
        }

        <div>
          <mat-form-field>
            <mat-label>Beviljat datum</mat-label>
            <input [formControl]="registerLoanPromiseForm.controls.dateOfIssue"
                   [matDatepicker]="pickerDateOfIssue"
                   matInput>
            <mat-datepicker-toggle [for]="pickerDateOfIssue"
                                   matSuffix></mat-datepicker-toggle>
            <mat-datepicker #pickerDateOfIssue></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Förfaller datum</mat-label>
            <input [formControl]="registerLoanPromiseForm.controls.validThru"
                   [matDatepicker]="pickerValidThru" matInput>
            <mat-datepicker-toggle [for]="pickerValidThru"
                                   matSuffix></mat-datepicker-toggle>
            <mat-datepicker #pickerValidThru></mat-datepicker>
          </mat-form-field>
        </div>

        @if (isPrivate) {
          <div>
            <div class="input-holder">
              <mat-checkbox
                id="bostadrattCheckbox"
                labelPosition="after"
                [formControl]="registerLoanPromiseForm.controls.property.controls.type"
                (change)="registerLoanPromiseForm.controls.property.controls.type.setValue($event.checked ? 'bostadsratt' : null)"
              >Bostadsrätt
              </mat-checkbox>
            </div>

            @if (registerLoanPromiseForm.controls.property.controls.type.value === 'bostadsratt') {
              <mat-form-field>
                <mat-label>Bostadsrätt max avgift</mat-label>
                <input
                  [formControl]="registerLoanPromiseForm.controls.property.controls.maxFee"
                  matInput spbFormatNumber>
              </mat-form-field>
            }
          </div>

          <div class="input-holder">
            <mat-checkbox
              id="conditionalCheckbox"
              labelPosition="after"
              [formControl]="registerLoanPromiseForm.controls.oldProperty.controls.futurePropertyOwnership"
              (change)="registerLoanPromiseForm.controls.oldProperty.controls.futurePropertyOwnership.setValue($event.checked ? 'intendToSell' : null)"
            >Villkorat nuv boende säljs
            </mat-checkbox>
          </div>
        }

        @if (registerLoanPromiseForm.controls.type.value === 'company') {
          <div>
            <mat-form-field>
              <mat-label>Ändamål</mat-label>
              <input [formControl]="registerLoanPromiseForm.controls.purpose"
                     matInput>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Säkerhet</mat-label>
              <input [formControl]="registerLoanPromiseForm.controls.insurance"
                     matInput>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Limitavgift</mat-label>
              <input [formControl]="registerLoanPromiseForm.controls.limitFee"
                     matInput spbFormatNumber>
            </mat-form-field>

            <mat-checkbox
              [checked]="!registerLoanPromiseForm.controls.confirmed.value"
              (change)="confirmedChange($event)">Obekräftad
            </mat-checkbox>
          </div>
        }

        @if (isPrivate) {
          <div class="input-holder">
            <mat-form-field>
              <mat-label>Max belåningsgrad</mat-label>
              <input
                maxlength="2"
                [formControl]="registerLoanPromiseForm.controls.ratio"
                matInput spbFormatNumber>
            </mat-form-field>
          </div>
        }

        <div class="input-holder">
          <mat-form-field>
            <mat-label>Beviljat belopp</mat-label>
            <input
              [formControl]="registerLoanPromiseForm.controls.approvedAmount"
              matInput spbFormatNumber>
          </mat-form-field>

          @if (registerLoanPromiseForm.controls.type.value) {
            <mat-form-field>
              <mat-label>Utnyttjat belopp</mat-label>
              <input [formControl]="registerLoanPromiseForm.controls.usedAmount"
                     matInput spbFormatNumber>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Kvarstående belopp</mat-label>
              <input
                [formControl]="registerLoanPromiseForm.controls.remainingAmount"
                matInput spbFormatNumber>
            </mat-form-field>
          }
        </div>

        <div>
          <mat-form-field class="message">
            <mat-label>Övrigt</mat-label>
            <textarea
              [formControl]="registerLoanPromiseForm.controls.adminInfo"
              matInput
              rows="3"
            ></textarea>
          </mat-form-field>
        </div>

        @if (isPrivate) {
          <div>
            <mat-form-field class="message">
              <mat-label>För detta lånelöfte gäller särskilt - visas på
                lånelöftesblankett
              </mat-label>
              <textarea
                [formControl]="registerLoanPromiseForm.controls.conditions"
                matInput
                rows="3"
                maxlength="200"
              ></textarea>
            </mat-form-field>

          </div>

          <mat-checkbox
            [formControl]="registerLoanPromiseForm.controls.fullyUsed">Nyttjat
            till slutfinansiering
          </mat-checkbox>
        }

      }
    </form>
  </div>
  <mat-dialog-actions align="end">
    <button mat-dialog-close matButton="outlined">Stäng</button>
    <button (click)="save()"
            [disabled]="!registerLoanPromiseForm.valid"
            matButton="filled">Spara
    </button>
  </mat-dialog-actions>
}